import $ from 'jquery';
import  'slick-carousel';

var initialFlexSliderWidth;

$(document).ready(initFlexSlider());
$(document).ready(function () {
  var initialFlexSliderWidth = getFlexSliderWidth();
});

$(window).resize(function() {
  var resizedFlexSliderWidth = getFlexSliderWidth();
  if (initialFlexSliderWidth != resizedFlexSliderWidth) {
    reinitFlexSlider();
    initialFlexSliderWidth = getFlexSliderWidth();
  }
});

function getFlexSliderWidth() {
  var slickSliderWidth = $('.slick-slider').width();
  return slickSliderWidth;
}

function initFlexSlider() {
  const prevBtn = '<div class="prev"><i class="icon icon-miniarrowleft"></i></div>';
  const nextBtn = '<div class="next"><i class="icon icon-miniarrowright"></i></div>';
  var totalSlides = $('[data-slides-total]').attr('data-slides-total');

  $('[flex-slider]').slick({
    asNavFor: '[flex-slider-controls]',
    dots: false,
    arrows: true,
    appendArrows: $('[js-flex-slider-arrows]'),
    nextArrow: nextBtn,
    prevArrow: prevBtn,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    mobileFirst: true,
    draggable: true,
    swipeToSlide: false,
    speed: 500,
    autoplaySpeed: 5000,
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    responsive: [
      {
        breakpoint: 960,
        settings: {
          // draggable: false,
          adaptiveHeight: true
        }
      },
      {
        breakpoint : 1280,
        settings: {
          // draggable: false,
        }
      }
    ]
  });

  $('[flex-slider-controls]').slick({
    asNavFor: '[flex-slider]',
    dots: false,
    slidesToShow: totalSlides,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: true,
    mobileFirst: true,
    speed: 500,
    autoplay: true,
    draggable: false,
    autoplaySpeed: 5000,
  });

}

function reinitFlexSlider() {
  $('[flex-slider]').slick('resize');
  $('[flex-slider-controls]').slick('reinit');
}



// WEBPACK FOOTER //
// ./assets/scripts/components/slider.js